<template>
    <Header :style="{ overflowX: 'auto', padding:'0',background: 'transparent' }">
        <div id="headerNav">
            <lang-component class="lang"></lang-component>
            <span class="pointer home" @click="goToHome">{{ $t('layout.home') }}</span>
            <Dropdown class="dropdown-qrcode" trigger="click">
                <a href="javascript:void(0)">
                    {{ $t('layout.applet') }}
                </a>
                <DropdownMenu slot="list">
                    <div class="qrcode-wrap">
                        <img src="~assets/qrcode.jpeg">
                        <div class="info">
                            <p>{{ $t('layout.scan') }}</p>
                            <p>{{ $t('layout.description') }}</p>
                        </div>
                    </div>
                </DropdownMenu>
            </Dropdown>
            <span v-if="!is_org" class="upgrade pointer" @click="handleUpgrade">{{ $t('pages.login.upgrade') }}</span>
            <span v-allow="'account,user'" v-if="is_org" class="campony-center" @click="goTo3('organization')">{{ $t('navigation.organization') }}</span>
            <!-- <Badge :count="messages_count" class="badge-wrap" @click.native="goTo('messages')">
                <a href="#" class="badge-text">消息</a>
            </Badge> -->
            <Avatar v-if="avatar" class="layout-avatar" icon="ios-person" :src="`/cym/${avatar}`" />
            <Dropdown trigger="click" style="margin-left: 14px;margin-right: 10px" placement="bottom-end">

                <a class="username line-overflow" href="javascript:void(0)">
                    {{ username }}
                    <Icon type="md-arrow-dropdown"/>
                </a>
                <DropdownMenu slot="list">
                    <DropdownItem @click.native="goTo('personalCenter')">{{ $t('navigation.personalCenter') }}</DropdownItem>
                    <DropdownItem v-if="organizationList.length !== 0 && !local_install" @click.native="handleChangeCount">{{ $t('layout.switchAccount') }}</DropdownItem>
                    <DropdownItem @click.native="logout">{{ $t('layout.logOut') }}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <upgrade-modal
            :show="upgradeModalShow"
            @cancel="handleUpgradeCancel"
            @confirm="handleUpgrageConfirm"
        ></upgrade-modal>
        <count-modal
            :show="countModalShow"
            :organizationList="organizationList"
            @cancel="hideCountModal"
        ></count-modal>
    </Header>  
</template>
<script>
    import { navigation, login } from '@/mixins/index'
    import upgradeModal from '@/views/components/upgradeModal'
    import countModal from './countModal'
    import langComponent from '@/views/login/components/language'

    export default {
        name: "",
        mixins: [navigation, login],
        components: {
            upgradeModal,
            countModal,
            langComponent
        },
        props: [],
        data () {
            return {
                upgradeModalShow: false,
                countModalShow: false,
                // organizationList: []
            }
        },
        computed: {
            messages_count() {
                return this.$store.state.unread_count
            },
            avatar() {
                return this.$store.state.avatar_uri
            },
            username() {
                return this.$store.state.username
            },
            is_org() {
                return this.$store.state.default_bucket_tokens.org
            },
            organizationList() {
                return this.$store.state.organizationList
            },
            local_install() {
                return this.$store.state.local_install
            }
        },
        methods: {
            logout: function () {
                localStorage.removeItem('account')
                localStorage.removeItem('organization_id')
                this.$router.replace('/login')
                this.$store.dispatch('Logout')
            },
            handleUpgrade() {
                this.upgradeModalShow = true
            },
            handleUpgradeCancel() {
                this.upgradeModalShow = false
            },
            handleUpgrageConfirm() {

            },
            handleChangeCount() {
                this.countModalShow = true
            },
            hideCountModal() {
                this.countModalShow = false
            },
            goToHome() {
                let name = 'personSpaces',
                    permissionList = this.$store.state.rolesList;
                if (this.is_org) {
                    name = 'companySpaces'
                }
                if (permissionList.length && permissionList.indexOf('content') === -1) {
                    name = 'mediaScreens'
                }
                this.$router.push({ name: name })
            }
        },
        mounted() {
            this.$store.dispatch('GET_ORGANIZATION_LIST')
        }
    }
</script>
<style scoped lang="less">
@deep: ~'>>>';
.layout-avatar, .home {
    margin-left: 40px;
}
.badge-wrap {
    position: relative;
    display: inline-block;
    margin: 0 40px;
    width: 40px;
    height: 30px;
    .badge-text {
        display: block;
        line-height: 20px;
        height: 20px;
    }
}
.badge-wrap .ivu-badge-count {
    height: 14px !important;
    line-height: 14px;
}
.upgrade, .dropdown-qrcode {
    margin-left: 40px;
}
.campony-center {
    cursor: pointer;
    margin-left: 40px;
}
.qrcode-wrap {
    width: 170px;
    img {
        display: block;
        margin: 0 auto;
        width: 100px;
        height: 100px;
    }
    .info {
        display: block;
        padding: 10px 0;
        font-size: 14px;
        text-align: center;
        p {
            height: 18px;
            line-height: 18px;
        }
    }
}
#headerNav {
    display: inline-block;
    width: 100%;
    min-width: 400px;
    text-align: right;
    .username {
        display: inline-block;
        max-width: 120px;
        vertical-align: top;
    }
    @{deep} .ivu-dropdown-menu {
        text-align: center;
    }
    /*@media screen and (max-width: 1000px) {
        .campony-center, .badge-wrap, .dropdown-qrcode {
            display: none;
        }
    }*/
}
</style>